import BackendService from "./BackendService";
import { STORAGE_KEYS } from "../const";
import * as ShopsHelper from "helpers/ShopsHelper";
import { getImageBase64 } from "helpers/ImageHelper";

async function getHeighestBillNumberFromServer(params) {
  return BackendService.getData("/sales/highest-bill-no/", {}, params);
}

async function loadShopProfile(useCache = true) {
  const shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID);
  if (!shopId) return null;

  if (useCache) {
    //const cachedData = await getCachedShopProfile();
    const cachedData = ShopsHelper.getCachedShopProfile();
    if (cachedData) return cachedData;
  }

  const resp = await BackendService.getData("/shop_profile/");

  if (resp && resp.shop_logo) {
    try {
      const base64Logo = await getImageBase64(resp.shop_logo);
      if (base64Logo) {
        resp.shop_logo = base64Logo;
      }
    } catch (err) {
      console.error("Failed to fetch image as base64", err);
    }
  }

  if (resp) {
    localStorage.setItem(STORAGE_KEYS.SHOP_PROFILE, JSON.stringify(resp));
  }

  return resp;
}

async function updateShopProfile(data, shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID)) {
  if (!shopId) return;
  return BackendService.postData(`/shop_profile/`, data);
}

async function getCachedPaymentModes() {
  const paymentModesStr = localStorage.getItem(STORAGE_KEYS.PAYMENT_MODES);
  if (!paymentModesStr) {
    return null;
  }
  return JSON.parse(paymentModesStr);
}

async function getPaymentModes({ useCache = true } = {}) {
  if (useCache) {
    const cachedModes = await getCachedPaymentModes();
    if (cachedModes) {
      return cachedModes;
    }
  }
  const paymentModes = await BackendService.getData("/payment-modes/", {}, {});
  localStorage.setItem(STORAGE_KEYS.PAYMENT_MODES, JSON.stringify(paymentModes));
  return paymentModes;
}

async function uploadShopLogo(data) {
  return BackendService.postData(`/shops/settings/logo/`, data, {});
}

const ShopService = {
  getHeighestBillNumberFromServer,
  loadShopProfile,
  updateShopProfile,
  getPaymentModes,
  uploadShopLogo,
  getCachedPaymentModes,
};

export default ShopService;
